export const payLinksItem: NavBarItem = {
  link: '/pay/pay-links/universal/',
  label: 'Pay Links',
};

export const paymentsItem: NavBarItem = {
  link: '/pay/payments/',
  label: 'Payments',
};

export const spendingLimitsItem: NavBarItem = {
  link: '/pay/spending-limits/',
  label: 'Spending Limits',
};

export const rewardsItem: NavBarItem = {
  link: '/pay/rewards/',
  label: 'Rewards',
};

export const getStartedItem: NavBarItem = {
  link: '/pay/activation/',
  label: 'Get started',
};

export const launchPackItem: NavBarItem = {
  link: 'https://coda.io/d/Welcome-to-iwocaPay_dx9e47R5IPf',
  label: 'Launch pack',
  opensNewTab: true,
  isExternalLink: true,
};

export const faqItem: NavBarItem = {
  link: 'https://support.iwoca.co.uk/en/collections/2145896-what-s-iwocapay',
  label: 'FAQs',
  opensNewTab: true,
  isExternalLink: true,
};

export const apiDocsItem: NavBarItem = {
  link: 'https://iwoca.co.uk/ecom/docs/',
  label: 'API Docs',
  opensNewTab: true,
  isExternalLink: true,
};

export const loansDashboardItem: NavBarItem = {
  link: '/account/',
  label: 'Loans dashboard',
};

export const integrationsItem: NavBarItem = {
  link: '/pay/integrations/',
  label: 'Integrations',
};

export const sellerDashboardItem: NavBarItem = {
  link: '/pay/dashboard/',
  label: 'Dashboard',
};

export type NavBarItem = {
  link: string;
  label: string;
  opensNewTab?: boolean;
  className?: string;
  isExternalLink?: boolean;
};
